// import { VouchersGiftcard } from '@mindfulchefuk/api-client'
import errorHandler from '@mindfulchefuk/utils/errorHandler'
import { spraypaintErrorMessage } from '@mindfulchefuk/utils/spraypaintUtils'
import { PostGiftCard } from '@mindfulchefuk/features/GiftCards/interfaces'
import { attr } from 'spraypaint'
import { ApplicationRecord } from '@mindfulchefuk/api-client'

const VouchersGiftcard = ApplicationRecord.extend({
  attrs: {
    trigger_payment: attr({ type: Boolean }),
    promotion_id: attr({ type: Number }),
    code: attr({ type: String }),
    amount: attr({ type: String }),
    completed_at: attr({ type: Date }),
    personalised_message: attr({ type: String }),
    payment_token: attr({ type: String }),
    send_gift_card_to_recipient: attr({ type: String }),

    // Recipient attributes
    delivery_type: attr({ type: String }),
    recipient_first_name: attr({ type: String }),
    recipient_last_name: attr({ type: String }),
    recipient_email: attr({ type: String }),
    recipient_address_street_1: attr({ type: String }),
    recipient_address_street_2: attr({ type: String }),
    recipient_address_locality: attr({ type: String }),
    recipient_address_postcode: attr({ type: String }),

    // Sender attributes
    customer_id: attr({ type: Number }),
    sender_first_name: attr({ type: String }),
    sender_last_name: attr({ type: String }),
    sender_email: attr({ type: String }),
  },
  static: {
    apiNamespace: '/vouchers',
    endpoint: '/gift_cards',
    jsonapiType: 'gift-cards',
  },
})

interface vouchersGiftCardParamsType {
  amount: string
  personalised_message: string
  payment_token?: string
  delivery_type: string
  recipient_first_name: string
  recipient_last_name: string
  recipient_email?: string
  recipient_address_street_1?: string
  recipient_address_street_2?: string
  recipient_address_locality?: string
  recipient_address_postcode?: string
  customer_id?: string
  sender_first_name?: string
  sender_last_name?: string
  sender_email?: string
  send_gift_card_to_recipient?: string
  trigger_payment: boolean
}

export const postGiftCards = async ({
  amount,
  sendGiftCardToRecipient,
  recipientFirstName,
  recipientLastName,
  recipientEmail,
  personalMessage,
  firstName,
  lastName,
  email,
  customerId,
  paymentToken,
  isLoggedInUser,
  triggerPayment = true,
}: PostGiftCard): Promise<{ data: { id: string } }> => {
  // Create our new DeliveriesDelivery ready to persist within the API

  let vouchersGiftCardParams: vouchersGiftCardParamsType = {
    amount,
    trigger_payment: triggerPayment,
    delivery_type: 'email',
    recipient_first_name: recipientFirstName,
    recipient_last_name: recipientLastName,
    personalised_message: personalMessage,
  }

  if (triggerPayment) {
    vouchersGiftCardParams = {
      ...vouchersGiftCardParams,
      payment_token: paymentToken,
    }
  }

  if (sendGiftCardToRecipient) {
    vouchersGiftCardParams = {
      ...vouchersGiftCardParams,
      recipient_email: recipientEmail,
      send_gift_card_to_recipient: sendGiftCardToRecipient,
    }
  }

  if (isLoggedInUser) {
    vouchersGiftCardParams = {
      ...vouchersGiftCardParams,
      customer_id: customerId,
    }
  } else {
    vouchersGiftCardParams = {
      ...vouchersGiftCardParams,
      sender_first_name: firstName,
      sender_last_name: lastName,
      sender_email: email,
    }
  }

  const giftCard = new VouchersGiftcard(vouchersGiftCardParams)

  try {
    // The result determines whether a POST operation
    // has been completed successfully
    const result = await giftCard.save()

    if (!result) {
      throw new Error(spraypaintErrorMessage(giftCard))
    }
  } catch (error) {
    // Track any failed attempts
    errorHandler(error)
    throw error
  }
  return { data: giftCard }
}
